// @generated by protoc-gen-zod-es v0.0.1 with parameter "target=ts,import_extension=none"
// @generated from file tenki/cloud/identity/v1beta1/permissions.proto (package tenki.cloud.identity.v1beta1, syntax proto3)
/* eslint-disable */

import { z } from "zod";

/**
 * @generated from message tenki.cloud.identity.v1beta1.WorkspacePermission
 */
export const workspacePermissionSchema = z.object({
  workspaceId: z.string(),
  view: z.boolean(),
  edit: z.boolean(),
  delete$: z.boolean(),
  viewMembers: z.boolean(),
  editMembers: z.boolean(),
  viewAudit: z.boolean(),
  viewBilling: z.boolean(),
  editBilling: z.boolean(),
  createProject: z.boolean(),
});

/**
 * @generated from message tenki.cloud.identity.v1beta1.ProjectPermission
 */
export const projectPermissionSchema = z.object({
  projectId: z.string(),
  view: z.boolean(),
  edit: z.boolean(),
  delete$: z.boolean(),
  viewMembers: z.boolean(),
  editMembers: z.boolean(),
});
